import * as React from 'react';

import cn from 'classnames';

const FormGroup: React.FC<React.PropsWithChildren<{ className?: string }>> = ({ className, children }) => (
  <div className={cn('mt-6', className)}>{children}</div>
);
export default FormGroup;
